import { getDisplayAsset } from '@kwenta/sdk/utils'
import { memo, useCallback } from 'react'
import styled from 'styled-components'

import SwitchAssetArrows from 'assets/svg/futures/switch-arrows.svg'
import InputButton from 'components/Input/InputButton'
import { selectMarketAsset } from 'state/futures/common/selectors'
import { setPreferences } from 'state/futures/reducer'
import { selectSelectedInputDenomination } from 'state/futures/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'

export const DenominationToggle = memo(() => {
	const assetInputType = useAppSelector(selectSelectedInputDenomination)
	const dispatch = useAppDispatch()
	const marketAsset = useAppSelector(selectMarketAsset)

	const toggleDenomination = useCallback(() => {
		dispatch(
			setPreferences({ selectedInputDenomination: assetInputType === 'usd' ? 'native' : 'usd' })
		)
	}, [dispatch, assetInputType])

	return (
		<StyledInputButton onClick={toggleDenomination}>
			{assetInputType === 'usd' ? 'USD' : getDisplayAsset(marketAsset)}{' '}
			<Container>
				<SwitchAssetArrows />
			</Container>
		</StyledInputButton>
	)
})

const Container = styled.div`
	margin-top: 4px;
`

const StyledInputButton = styled(InputButton)`
	font-size: 10px;
	font-weight: 500;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	border-radius: 3px;
	background-color: ${(props) =>
		props.theme.colors.selectedTheme.input.denominationToggle.background};
`
